<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showModal"
  style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow rounded">
      <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button type="button" class="btn-close" (click)="cancel()"></button>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
        <div *ngIf="meta?.txId" class="d-flex align-items-center gap-2 mt-2">
          <small class="text-muted">Transaction ID:</small>
          <code class="tx-id">{{ meta.txId }}</code>
          <button class="btn btn-sm btn-outline-secondary ms-auto" (click)="copyTxId()">Copy</button>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancel()">Close</button>
        <button class="btn btn-danger" (click)="confirm()">OK</button>
      </div>
    </div>
  </div>
</div>